import { SearchIcon } from "@heroicons/react/outline";

interface SearchInputProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = ({
  searchValue,
  onSearchChange,
  placeholder = "Search by id",
  className = "",
}: SearchInputProps) => (
  <div className={`relative ${className}`}>
    <input
      type="text"
      value={searchValue || ""}
      onChange={(e) => onSearchChange?.(e.target.value)}
      placeholder={placeholder}
      className="w-full h-10 pl-3 pr-10 text-sm border border-neutral-900 rounded
                 focus:outline-none focus:ring-2 focus:ring-rebrandIndigo-500 focus:border-rebrandIndigo-500"
    />
    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
      <SearchIcon className="w-4 h-4 text-gray-400" />
    </div>
  </div>
);

export default SearchInput;
